export class Chofer{
 NAME: any;
 LICENSE_NUMBER: any;
 RFC: any;
 CP: any;
 SUBURB: any;
 STREET: any;
 OUTDOOR_NUMBER: any;
 INTERIOR_NUMBER: any;
 REFERENCE: any;
 pais: number;
 estado: number;
 ciudad: number;
 CITY_ID: number;
 loacs?: string;
 DRIVER_ID:number;
 SAT_FIGURE_TYPE_ID: number;
}


// WEBPACK FOOTER //
// ./src/app/models/chofer.ts